import { Component, Input, OnInit } from '@angular/core';
import { srSpeak } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-search-count-row',
    template: `
    <div class="tw-w-full tw-pt-1">
      <app-action-row>
        <div left1 class="tw-flex tw-min-w-0 tw-w-full tw-flex-col tw-gap-2">
          <div class="tw-font-bold tw-text-[16px]" [ngPlural]="count">
            <ng-template ngPluralCase="=1">
              1 {{ resultSingle | titlecase | translation: translationRequest }} {{ 'found' | translation: translationRequest }} {{ detail | translation: translationRequest }}{{ (isSupervisor ?' for filtered by manager '+supervisorFullName+', includes '+ (!isInDirectInclude ?'direct reports only.':'direct and indirect reports.'):'') | translation : translationRequest}}
            </ng-template>
            <ng-template ngPluralCase="other">
              {{ count }} {{ resultPlural | titlecase | translation: translationRequest }}  {{ 'found' | translation: translationRequest }} {{ detail | translation: translationRequest }}{{ (isSupervisor ?' for filtered by manager '+supervisorFullName+', includes '+ (!isInDirectInclude ?'direct reports only.':'direct and indirect reports.'):'') | translation : translationRequest}}
            </ng-template>
          </div>
          @if (count >= maxSearchResults) {
            <app-toast
              class="tw-w-full tw-max-w-full"
              [disableMarginBottom]="true"
              icon="info"
              >{{
                (maxResultsMsg
                  ? maxResultsMsg
                  : 'Maximum ' +
                  resultPlural +
                  ' are displayed, consider adding additional search parameters.') | translation: translationRequest
                }}
            </app-toast>
          }
        </div>
      </app-action-row>
    </div>
    `,
    styles: ``,
    standalone: false
})
export class SearchCountRowComponent implements OnInit {
  @Input()
  count: number = 0;

  @Input()
  maxSearchResults: number = 200;

  @Input()
  resultSingle = 'claim';

  @Input()
  resultPlural = 'claims';

  @Input()
  maxResultsMsg: string = '';

  @Input()
  detail: string = '';

  @Input()
  supervisorFullName : string = '';

  @Input()
  isSupervisor : boolean = false;

  @Input()
  isInDirectInclude : boolean = false;


  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  async ngOnInit() {
    if (this.count > 0) {
      await srSpeak(this.count + ' search results found', 'polite');
      if (this.count === this.maxSearchResults) {
        srSpeak(
          'Maximum search results are displayed, consider adding additional search parameters',
          'polite'
        );
      }
    }
  }
}
